import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient, useLazyQuery } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import HtlAgnQuataEdit from "./HtlAgnQuataEdit";
import { ProgressSpinner } from 'primereact/progressspinner';




import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $contIdSeq: Int!
    $quataType: String

  ) {
    tbl_cont_quata_def(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        quata_type: { _eq: $quataType }
        cont_id: { _eq: $contIdSeq }
        
      }
    ) {
      firm_main_code
      firm_sub_code
      id_seq
      cont_id
      season_id
      quata_type
    
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_PER_DEFS = gql`
  query GetPerDefs($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }) {
      id_seq
      period
      start_date
      end_date
      min_stay
      release
    }
  }
`;

const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
    $quataIdSeq: Int
  ) {
    tbl_cont_quata_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
        qua_id: { _eq: $quataIdSeq }
        

      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      get_room_name {
        r_type_name
      }
      base_quata
      period
      qua_id
    }
  }
`;

const GET_PER_BASE_FOR_INS = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int,
    $quataIdSeq: Int
  ) {
    tbl_cont_quata_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq },
        qua_id: { _eq: $quataIdSeq },
        quata_type: { _eq: "QUAT" }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      cont_id
      room_type
      room_class
      base_quata
      period
      qua_id
      start_date
      end_date
    }
  }
`;

const INSERT_MULTIPLE_ROOM_TYPE_AVA_DTL_STS = gql`
  mutation InsertMultipleRoomTypeAvaDtlSts($objects: [tbl_htl_room_type_ava_dtl_sts_insert_input!]!) {
    insert_tbl_htl_room_type_ava_dtl_sts(objects: $objects) {
      returning {
        cont_id
        firm_main_code
        firm_sub_code
        date
        room_class
        room_type
        room_total_contg
        room_contg_use
        room_gua_use
      }
    }
  }
`;

const UPDATE_ROOM_TYPE_AVA_DTL_STS = gql`
  mutation UpdateRoomTypeAvaDtlSts(
    $cont_id: Int!,
    $firm_main_code: String!,
    $firm_sub_code: String!,
    $date: date!,
    $room_class: String!,
    $room_type: String!,
    $room_total_contg: Int!
  ) {
    update_tbl_htl_room_type_ava_dtl_sts(
      where: {
        cont_id: { _eq: $cont_id },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code },
        date: { _eq: $date },
        room_class: { _eq: $room_class },
        room_type: { _eq: $room_type }
      },
      _set: {
        room_total_contg: $room_total_contg
      }
    ) {
      affected_rows
    }
  }
`;




const GET_HTL_SEA = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;



const INSERT_CONT_SEA = gql`
  mutation InsertContractSea(
    $contSeaIdSeq: Int!
    $contIdSeq: Int!
    $htlSeaIdSeq: Int!
    $firmMainCode: String
    $firmSubCode: String
    $startDate: date
    $endDate: date
    $quataType: String
   
  ) {
    insert_tbl_cont_quata_def(
      objects: {
        id_seq: $contSeaIdSeq,
        cont_id: $contIdSeq,
        season_id: $htlSeaIdSeq,
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        quata_type: $quataType,
       
      
      }
    ) {
      affected_rows
    }
  }
`;

const GET_TBL_CONT_PER_DEF = gql`
  query GetTblContPerDef(
        $firmMainCode: String,
        $firmSubCode: String,
        $contIdSeq: Int
        ) {
    tbl_cont_per_def(where: {
                firm_main_code: { _eq: $firmMainCode }, 
                firm_sub_code: { _eq: $firmSubCode },
                cont_id: { _eq: $contIdSeq }
             }) {
      id_seq
      cont_id
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      min_stay
      release
      get_room_types {
        r_class_code
        r_type_code
      }
    
    }
  }
`;





const INSERT_HTL_PER_RECORDS_MUTATION_N = gql`
  mutation InsertHtlPerRecordsIntoContPerBase($records: [tbl_cont_quata_base_insert_input!]!) {
    insert_tbl_cont_quata_base(objects: $records) {
      affected_rows
    }
  }
`;


const UPDATE_BASE_PRICE = gql`
mutation UpdateContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $contSeaIdSeq: Int
  $basePeriod: String
  $roomType: String
  $basePrice: Int 
  $quataType: String
  
) {
  update_tbl_cont_quata_base(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
      sea_id: { _eq: $contSeaIdSeq }
      period: { _eq: $basePeriod }
      room_type: { _eq: $roomType }
      quata_type: { _eq: $quataType }
    },
    _set: {
     base_quata: $basePrice,
     
    }
  ) {
    affected_rows
  }
}
`;


const HtlAgnQuota = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const {varCode15, setVarCode15} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';

    const [loadingprc, setLoadingprc] = useState(false);
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4, quataType: "QUAT" },
    });
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    const [InsertContractSea] = useMutation(INSERT_CONT_SEA);
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2);
    
    const [insertPerBaseRecords] = useMutation(INSERT_HTL_PER_RECORDS_MUTATION_N);
   

  
  
    const firmData = data && data.tbl_cont_quata_def ? data.tbl_cont_quata_def[0] : null;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.id_seq :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.season_id :"");
    const [quataType, setQuataType] = useState(firmData ? firmData.quata_type :"QUAT");
    const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
    const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());


    
    const [UpdateContBasePrice] = useMutation(UPDATE_BASE_PRICE);
   

    const [basePeriod, setBasePeriod] = useState();
    const [roomType, setRoomType] = useState();
    const [basePrice, setBasePrice] = useState();
    const [basePricetrg, setBasePriceTrg] = useState(1);
    const [idSeqtrg, setIdSeqTrg] = useState();
   


    const { loading: htlseaLoading, error: htlseaError, data: htlseaData } = useQuery(GET_HTL_SEA, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });

  

      const { loading: htlperroomLoading, error: htlperroomError, data: htlperroomData } = useQuery(GET_TBL_CONT_PER_DEF, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
      });

   

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);


  
 const { loading: loadingPerDefs, error: perDefError, data: perDefsData, refetch: refetchPerDefs2  } = useQuery(GET_PER_DEFS, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });
 
 
 const { loading: loadingPerBase, error: perBaseError, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq, quataIdSeq: contSeaIdSeq },
  });




  

  function getDatesInRange(startDate, endDate) {
    const date = new Date(startDate);
    const dates = [];
  
    while (date <= new Date(endDate)) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
  
    return dates;
  }
  
  const [getPerBaseData, { loading: loadingPerBase2, error: perBaseError2, data: perBaseData2, refetch: refechquata }] = useLazyQuery(GET_PER_BASE_FOR_INS);
const [insertMultipleRoomTypeAvaDtlSts] = useMutation(INSERT_MULTIPLE_ROOM_TYPE_AVA_DTL_STS);

function getDatesInRange(startDate, endDate) {
  const date = new Date(startDate);
  const dates = [];

  while (date <= new Date(endDate)) {
    dates.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

const handleFetchAndInsert = async () => {
  try {
    // Query'i tetikle
    await refechquata();
    const { data } = await getPerBaseData({
      variables: { firmMainCode:firmMainCode, firmSubCode:firmSubCode, contIdSeq:contIdSeq, quataIdSeq: contSeaIdSeq }
    });

    if (!data) {
      alert('No data to process');
      return;
    }

    const objects = [];

    for (const row of data.tbl_cont_quata_base) {
      const dates = getDatesInRange(row.start_date, row.end_date);

      for (const date of dates) {
        objects.push({
          cont_id: row.cont_id,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          date: date.toISOString().split('T')[0],
          room_class: row.room_class,
          room_type: row.room_type,
          room_total_contg: row.base_quata,
          room_contg_use: 0,
          room_gua_use: 0
        });
      }
    }

    console.log('Objects to insert:', objects);

    // Insert işlemini yap
    const response = await insertMultipleRoomTypeAvaDtlSts({
      variables: { objects }
    });

    console.log('Insert response:', response.data);
    alert('Data inserted successfully');
  } catch (error) {
    console.error('Error fetching or inserting data:', error);
    alert('Error fetching or inserting data');
  }
};

const [updateRoomTypeAvaDtlSts] = useMutation(UPDATE_ROOM_TYPE_AVA_DTL_STS);

const handleFetchAndUpdate = async () => {
  setLoadingprc(true);
  try {
    // Query'i yeniden tetikle
    await refechquata();

    const { data } = await getPerBaseData({
      variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq, quataIdSeq: contSeaIdSeq }
    });

    if (!data) {
      alert('No data to process');
      return;
    }

    const objects = [];

    for (const row of data.tbl_cont_quata_base) {
      const dates = getDatesInRange(row.start_date, row.end_date);

      const roomTotalContg = row.base_quata !== null && row.base_quata !== undefined ? row.base_quata : 0;

      for (const date of dates) {
        objects.push({
          cont_id: row.cont_id,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          date: date.toISOString().split('T')[0],
          room_class: row.room_class,
          room_type: row.room_type,
          room_total_contg: roomTotalContg,
          
        });
      }
    }

    console.log('Objects to update:', objects);

    // 100 güncelleme işlemi gerçekleştirin
    for (let i = 0; i < objects.length; i += 100) {
      const chunk = objects.slice(i, i + 100);
      const updatePromises = chunk.map(obj => 
        updateRoomTypeAvaDtlSts({ variables: obj })
      );

      await Promise.all(updatePromises);
    }

    alert('Data updated successfully');
    } catch (error) {
      console.error('Error fetching or updating data:', error);
      alert('Error fetching or updating data');
    } finally {
      setLoadingprc(false); // İşlem tamamlandıktan sonra loading durumunu false yap
    }
  };

 

 

  /* her bir kayıt icin id_seq al

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

  const handleInsertBaseRecords = async () => {
    try {
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = [];
  
      for (const record of htlperroomData.tbl_cont_per_def) {
        // Her bir satır için ayrı bir ID_SEQ al
        const updatedIdSeq = String(await handleUpdateIdSeq3());
  
        // get_room_types'tan gelen tüm elemanları işle
        const roomTypeRecords = record.get_room_types.map((roomType) => ({
          cont_id: contIdSeq,
          firm_main_code: firmMainCode,
          firm_sub_code: firmSubCode,
          sea_id: contSeaIdSeq,
          per_id: record.id_seq,
          room_class: roomType.r_class_code,
          room_type: roomType.r_type_code,
          period: record.period,
          start_date: record.start_date,
          end_date: record.end_date,
          currency: updatedIdSeq,
          min_stay: record.min_stay,
          release: record.release,
        }));
  
        //  her bir eleman recordsToInsert dizisine ekle
        recordsToInsert.push(...roomTypeRecords);
      }
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerBaseRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_per_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      window.alert("Contract Season Base insert successfully!");
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
    
    }
  }; */

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

  const handleInsertBaseRecords = async () => {
    try {
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = [];
  
      for (const record of htlperroomData.tbl_cont_per_def) {
        // get_room_types'tan gelen tüm elemanları işle
        const roomTypeRecords = await Promise.all(record.get_room_types.map(async (roomType) => {
          // Her bir satır için ayrı bir ID_SEQ al
          const updatedIdSeq = await handleUpdateIdSeq3();
  
          // get_room_types'tan gelen tüm elemanları işle
          const roomTypeRecord = {
            cont_id: contIdSeq,
            id_seq: updatedIdSeq,
            firm_main_code: firmMainCode,
            firm_sub_code: firmSubCode,
            sea_id: htlSeaIdSeq,
            per_id: record.id_seq,
            room_class: roomType.r_class_code,
            room_type: roomType.r_type_code,
            period: record.period,
            start_date: record.start_date,
            end_date: record.end_date,
            qua_id: contSeaIdSeq,
            quata_type: quataType,
            // currency: updatedIdSeq,
            // min_stay: record.min_stay,
            // release: record.release,
          };
  
          return roomTypeRecord;
        }));
  
        // her bir eleman recordsToInsert dizisine ekle
        recordsToInsert.push(...roomTypeRecords);
      }
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertPerBaseRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_cont_quata_base.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      //handleInsertTempRecords2();
      refetch();
      refetchPerDefs2();
      refetchPerDefs();
      window.alert("Contract Season Base insert successfully!");
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
      console.error('Ekstra hata bilgisi:', error.graphQLErrors, error.networkError);
    
    }
  };




  useEffect(() => {
    handleBasePriceUpdate();
  }, [basePricetrg]);

  
  const handleBasePriceUpdate = () => {
    UpdateContBasePrice({
      variables: {
        contIdSeq: contIdSeq,
        contSeaIdSeq: htlSeaIdSeq,
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        basePeriod: basePeriod,
        roomType: roomType,
        basePrice: basePrice,
        quataType: quataType,
       

        
      },
    })
      .then(() => {
        window.alert("Contract Base updated successfully!");
        refetch();
        
       refetchPerDefs();
       
      })
      .catch((error) => {
        console.error("Error updating Cont Base Price:", error);
      });
  };



  

  useEffect(() => {
    if (!loadingPerDefs && perDefsData) {
      const dynamicColumns = perDefsData.tbl_cont_per_def.map((def) => {
        const startDate = new Date(def.start_date);
        const endDate = new Date(def.end_date);
  
        const formattedStartDate = startDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });
        const formattedEndDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric' });
  
        return {
          field: def.period,
          header: (
            <>
              {def.period}
              <br />
              ({formattedStartDate} - {formattedEndDate})
            </>
          ),
          body: (rowData) => (
            <div>
              {rowData['room_type']} - {rowData['get_room_name']?.r_type_name}
            </div>
          ),
        };
      });
  
      setTableColumns([
        { field: 'room_type', header: 'Room Type' },
        ...dynamicColumns,
      ]);
    }
  }, [loadingPerDefs, perDefsData]);
  
  useEffect(() => {
    if (!loadingPerBase && perBaseData) {
      const uniqueRoomTypes = [...new Set(perBaseData.tbl_cont_quata_base.map((item) => item.room_type))];
  
      const dynamicData = uniqueRoomTypes.map((roomType) => {
        const rowData = {
          room_type: roomType,
        };
  
        perBaseData.tbl_cont_quata_base
          .filter((item) => item.room_type === roomType)
          .forEach((item) => {
            rowData[item.period] = item.base_quata;
            rowData['r_type_name'] = item.get_room_name?.r_type_name; 
          });
  
        return rowData;
      });
    //  fetch();
  
      setTableData(dynamicData);
    }
  }, [loadingPerBase, perBaseData]);


    

    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
       // setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.id_seq);
          setHtlSeaIdSeq(firmData.season_id);
          setQuataType(firmData.quata_type);
          setStartDate(new Date(firmData.start_date));
          setEndDate(new Date(firmData.end_date));
          refetch();  
          
    
        }
      }, [firmData]);

      const { xloading, xdata } = useQuery(GET_HTL_SEA, {
        variables: {
          firmMainCode: firmMainCode,
          firmSubCode: firmSubCode
          
        },
      });

   

      

      const [selectedRowData, setSelectedRowData] = useState(null);
      const [displayDialog, setDisplayDialog] = useState(false);

      const onEditButtonClick = (rowData) => {
       // setSelectedRowData(rowData);
        setDisplayDialog(true);
        setVarCode3(htlSeaIdSeq);
        setVarCode15(quataType);
        // handleEditButtonClick'i çağırırken doğru parametreleri geçir
     //   handleEditButtonClick(rowData);
      };



   


      const handleUpdateIdSeq2 = async () => {
        try {
          const { data } = await updateIdSeq2({
            variables: {
              type: 'MFIRM', 
            },
          });
          const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
          setContSeaIdSeq(updatedIdSeq); 
         // setVarCode(updatedIdSeq.toString());  
          console.log(contSeaIdSeq);         
           
          
        } catch (error) {
          console.error('Güncelleme hatası:', error);
        }
      };


      const handleUpdateIdSeq = async () => {
        const requiredFields = ['htlSeaIdSeq' ]; // Required fiels
        const customFieldNames = {
            htlSeaIdSeq: "Hotel Sezon Kodu"
        
    
        };
        const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
      
        if (emptyFields.length === 0) {
          try {
            const { data } = await updateIdSeq2({
              variables: {
                type: 'MFIRM', 
              },
            });
            const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
            console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
            setContSeaIdSeq(updatedIdSeq); 
            setIdSeqTrg(updatedIdSeq);
            
            console.log(contSeaIdSeq);
            // setVarCode(updatedIdSeq.toString());  
          } catch (error) {
            console.error('Güncelleme hatası:', error);
          }
        } else {
          
          const emptyFieldsMessage = `Lütfen Hotel Sezonu doldurun: ${emptyFields.join(', ')}`;
         // console.log(emptyFieldsMessage);
          window.alert(emptyFieldsMessage);
        }
      };
      
      const validateForm = (requiredFields, customFieldNames) => {
        // Tüm gerekli alanları kontrol et
        for (const field of requiredFields) {
          if (!eval(field)) {
            return false;
          }
        }
      
        return true;
      };
      
      const getEmptyFields = (requiredFields, customFieldNames) => {
        const emptyFields = [];
      
        // Boş olan alanları bul
        for (const field of requiredFields) {
          if (!eval(field)) {
            emptyFields.push(customFieldNames[field]);
          }
        }
      
        return emptyFields;
      };
    
    
        useEffect(() => {
        // newId değeri bağlamdaki yeni değeri yansıtır
        if (idSeqtrg !== '') {
          // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
          handleinsert();  
        
        }
      }, [idSeqtrg]);

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
      
        }
      }, [varCode4, setContIdSeq, someCondition]);


          

      const handleinsert = () => {
        InsertContractSea({
         variables: {
           firmSubCode: firmSubCode,
           firmMainCode: firmMainCode,
           firmSubCode: firmSubCode,
           contIdSeq: varCode4,
           contSeaIdSeq: contSeaIdSeq,
           htlSeaIdSeq: htlSeaIdSeq,
           quataType: quataType,
          
          
         },
       })
         .then(() => {
           window.alert("Contract Season insert successfully!");
         //  handleInsertTempRecords();
           refetch();
        
         })
         .catch((error) => {
           console.error("Error insert cont Season:", error);
         });
     };
    
    
      const handleDialogCancel = () => {
        // İptal edildiğinde, seçili satır verilerini sıfırlayın ve dialog penceresini kapatın
        setSelectedRowData(null);
        setDisplayDialog(false);  
        refetch();
        refetchPerDefs(); 

      };
      
      
        const [editingRowData, setEditingRowData] = useState(null);
        
        const onCellEditInit = (e) => {
            const { rowData } = e;
          
            // Eğer editingRowData zaten set edilmişse tekrar set etme
            if (!editingRowData) {
              setEditingRowData(rowData);
            }
          };
          useEffect(() => {
            // Bu useEffect, editingRowData state'i güncellendiğinde çalışacak
            if (editingRowData) {
              // Eğer editingRowData değeri mevcutsa, burada gerekli işlemleri gerçekleştirin
              console.log('editingRowData:', editingRowData);
            }
          }, [editingRowData]);
          
          const onCellEditComplete = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const roomType = rowData['room_type'];
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Room fr Type:', roomType);
            setBasePrice(value);
            setRoomType(roomType);
            setBasePeriod(field);
            setBasePriceTrg(basePricetrg + 1);
            
           
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
             
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const onCellEditComplete2 = (e) => {
            console.log('Hücre düzenleme tamamlandı:', e);
          
            const { field, value, rowData } = e;
          
            // Eğer rowData undefined ise, hatayı konsola yazdır ve işlemi sonlandır
            if (!rowData) {
              console.error('rowData is undefined!');
              return;
            }
          
            const roomType = rowData['room_type'];
            const perId = rowData['per_id'];
            const roomName = rowData['r_type_name'];
          
            // Düzenlenen hücre bilgilerini konsola yazdırma
            console.log('Field:', field);
            console.log('Value:', value);
            console.log('Room xType:', roomType);
            console.log('Per:', perId);
            console.log('name:', roomName);
            console.log('id:', id_seq);

            setVarCode6(field);
            setVarCode7(roomType);
           
           


            
           
            onEditButtonClick();
          //  setDisplayDialog(true);
          
            // Ilgili satırdaki veriyi kontrol et ve undefined değilse işlemleri gerçekleştir
            if (editingRowData) {
              console.log('Row Data:', editingRowData);
          
              // Örneğin, period, base_price, room_type gibi özel bilgilere erişebilirsiniz
              const period = editingRowData['period'];
              const basePrice = editingRowData['base_price'];
              const roomType = editingRowData['room_type'];
              
              console.log('Period:', period);
              console.log('Base Price:', basePrice);
              console.log('Room Type:', roomType);
          
              // Düzenleme tamamlandığında yapılacak işlemleri burada gerçekleştirin
           //   setEditingRowData(null); // Düzenleme tamamlandığında state'i temizle
            } else {
              console.error('editingRowData is undefined!');
            }
          };

          const RoomTypeEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            return (
              <div>
                {value}
              </div>
            );
          };

          const TextEditor = (props) => {
            const { value, onValueChange, rowData } = props;
          
            const handleKeyPress = (e) => {
              if (e.keyCode === 13) {
                // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                onCellEditComplete({ field: props.field, value: e.target.value, rowData });
            //    handleEditButtonClick({ field: props.field, value: e.target.value, rowData }); // Bu satırı ekleyin
              }
            };

            const handleKeyPress2 = (e) => {
                
                  // Enter tuşuna basıldığında yapılacak işlemleri burada tanımlayabilirsiniz
                  onCellEditComplete2({ field: props.field, value: null, rowData });
              //   handleEditButtonClick({ field: props.field, value: null, rowData }); // Bu satırı ekleyin
              
              };
              //<Button label="Edit" onClick={() => handleKeyPress2(rowData)} />
          
            return (
                <div className="flex h-2 items-center">
                <InputText
                  value={value}
                  onChange={(e) => {
                    if (onValueChange) {
                      onValueChange(e.target.value);
                    }
                  }}
                  onKeyDown={handleKeyPress}
                  className="w-3/4 mr-2 p-0"
                />
                <button
                  onClick={() => handleKeyPress2(rowData)}
                  className="cursor-pointer ml-2 flex items-center justify-start"
                >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
               </svg>
                </button>
              </div>
            );
          };
       

              useEffect(() => {
                if (htlseaData && htlSeaIdSeq) {
                  const selectedSea = htlseaData.tbl_htl_season.find(sea => sea.id_seq === htlSeaIdSeq);
                  
                  if (selectedSea) {
                    setStartDate( new Date(selectedSea.start_date));              
                    setEndDate( new Date(selectedSea.end_date));
                  }
              
                  console.log("start date:", selectedSea ? selectedSea.start_date : null);
                }
              }, [htlSeaIdSeq, htlseaData]);
          

         /* const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: item.desc,
              value: item.id_seq,
              name: item.desc, 
            }))
          : [];*/

          const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: (
                <div>
                  <div>{item.desc}</div>
                  <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
          <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
                </div>
              ),
              value: item.id_seq,
            }))
          : [];
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
          <Fieldset>
            <div className="flex">
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Quata Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contSeaIdSeq}
                  onValueChange={(e) => setContSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

              
               <div className="w-1/8 mr-2 gap-3">
               <label className="block font-medium text-gray-950 justify-content-center gap-4"
                htmlFor="username">  {"Type"}</label>
               <InputText className="h-11  w-full" 
               id="username" value={quataType}
               onChange={(e) => setQuataType(e.target.value)}
               readOnly
               />
             </div>
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Cont Season Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={htlSeaIdSeq}
                  onValueChange={(e) => setHtlSeaIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

              <div>
        <label htmlFor="roomClassDropdown" className="font-medium flex text-gray-700">
        {"Hotel Seasons"}
       </label>
       <Dropdown
       className="h-11 mr-10 w-56 rounded-md" 
        style={{ width: '384px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={htlSeaIdSeq}
         options={htlSeaItems}
         onChange={(e) => setHtlSeaIdSeq(e.value)}
         placeholder={"select_a_department_holder"}
         />
       </div>

   

            </div>
            <br></br>
            
            <button
  className={`bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md ${
    contSeaIdSeq ? 'cursor-not-allowed opacity-50' : ''
  }`}
  onClick={contSeaIdSeq ? null : handleUpdateIdSeq}
  disabled={!!contSeaIdSeq}
>
  {contSeaIdSeq ? 'Season Quata saved' : 'New Season Quata'}
</button>



      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleInsertBaseRecords}
      >
        {"Get Rooms"}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleFetchAndInsert}
      >
        {"Create Quata"}
      </button>

      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleFetchAndUpdate}
      >
        {"Update quata"}
      </button>

      <Dialog header="Processing" visible={loadingprc} modal>
        <div className="p-d-flex p-jc-center p-ai-center" style={{ height: '100px' }}>
          <ProgressSpinner />
        </div>
      </Dialog>
   

      

     

     


    
      
      

          </Fieldset>
      
          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Contract Season Quata "}
            </span>
          }
          className="ml-5 flex"
        >
      <div>
  

  <DataTable
value={tableData}
frozenHeader
scrollable
showGridlines
stripedRows="true"
editMode="cell"
size={"small"}
onCellEditComplete={onCellEditComplete}
footerColumnGroup={"footerGroup"}
>
{tableColumns.map((column) => (
 <Column
   key={column.field}
   editor={column.field === 'room_type' ? (props) => <RoomTypeEditor {...props} /> : (props) => <TextEditor {...props} />}
   field={column.field}
   className="text-sm font-semibold text-right"  
   header={<span className="text-sm text-center font-semibold text-gray-900">{column.header}</span>}
   body={(rowData) => {
     if (column.field === 'room_type') {
       return (
         <div>
           {rowData['room_type']} - {rowData['r_type_name']}
         </div>
       );
     } else {
       // Diğer kolonlar için normal içerik
       return <div>{rowData[column.field]}</div>;
     }
   }}
   style={{
     textAlign: 'left',
     width: column.field === 'room_type' ? '30rem' : '10rem', // Genişlik ayarı
     fontWeight: column.field === 'room_type' ? 'bold' : 'Light', // Bold stil
   }}
 />
))}
</DataTable>

   {/* Dialog penceresi */}
   <Dialog header={"Contract Quata "} visible={displayDialog} style={{ width: '50vw' }} onHide={handleDialogCancel}>
   
       <div>

         <HtlAgnQuataEdit/>
    
      
       </div>
     
   </Dialog>
 </div>

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Contract Guarantee"}
            </span>
          }
          className="ml-5 flex"
        >
    
             <HtlAgnSeaReduction/>

              </TabPanel>
            
          </TabView>
      
          
        </>
      );
      
  };
  
  export default HtlAgnQuota;

  /*
  <div>
      <DataTable value={tableData} frozenHeader scrollable showGridlines editMode="cell" onCellEditComplete={onCellEditComplete}  onCellEditInit={onCellEditInit} >
        {tableColumns.map(column => (
          <Column key={column.field} editor={(props) => textEditor(props)} field={column.field} header={column.header} />
        ))}
      </DataTable>
    </div>
    <DataTable
  value={tableData}
  editMode="cell"
 
>
  {tableColumns.map((column) => (
    <Column
      key={column.field}
      field={column.field}
      header={column.header}
      editor={textEditor}
    />
  ))}
</DataTable> 

    <DataTable
       value={tableData}
        frozenHeader
         scrollable 
         showGridlines 
         editMode="cell" 
         onCellEditComplete={onCellEditComplete}
         >
        {tableColumns.map((column) => (
          <Column
            key={column.field}
            editor={(props) => textEditor(props)}
            field={column.field}
            className="text-sm text-left"  
         //   header={column.header}
            header={<span className="text-base font-semibold text-gray-900">{column.header}</span>}
            style={{ textAlign: 'left', width: '10rem' }}
          />
        ))}
      </DataTable>
      
      */


      
  